import * as React from "react";
import { SVGProps, memo } from "react";

const SvgCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg width={23} height={23} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.888 12.278a4.364 4.364 0 1 1-8.727 0 4.364 4.364 0 0 1 8.727 0Zm-1.636 0a2.727 2.727 0 1 1-5.455 0 2.727 2.727 0 0 1 5.455 0Z"
      fill="#fff"
    />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m14.148 3.559 1.507 1.731h3.54c.602 0 1.09.489 1.09 1.091v11.804a1.09 1.09 0 0 1-1.09 1.091H3.805a1.09 1.09 0 0 1-1.09-1.09V6.38c0-.602.488-1.09 1.09-1.09h3.541l1.642-1.732h5.16ZM8.05 6.927l1.642-1.732h3.71l1.508 1.732h3.74V17.64H4.35V6.927h3.7Z"
      fill="#fff"
    />
  </svg>
);

const Memo = memo(SvgCamera);

export default Memo;
